namespace Matrix.Rebalancer {
    export namespace ModellingViewColumnService {
        export const baseUrl = 'Rebalancer/ModellingViewColumn';

        export declare function Create(request: Serenity.SaveRequest<ModellingViewColumnRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ModellingViewColumnRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ModellingViewColumnRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ModellingViewColumnRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Rebalancer/ModellingViewColumn/Create",
            Update = "Rebalancer/ModellingViewColumn/Update",
            Delete = "Rebalancer/ModellingViewColumn/Delete",
            Retrieve = "Rebalancer/ModellingViewColumn/Retrieve",
            List = "Rebalancer/ModellingViewColumn/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ModellingViewColumnService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
